import { gql } from '@apollo/client'
import { POST_CARD_FIELDS } from '../fragments/postCardFields'

export const GET_CHANNEL_POSTS = gql`
  query GetChannelPosts($channelId: ID!, $limit: Int, $offset: Int) {
    channelPosts(channelId: $channelId, limit: $limit, offset: $offset) {
      ...PostCardFields
    }
  }
  ${POST_CARD_FIELDS}
`
